import { SEC_ApiCall, SEC_DataApiPost } from '../func.js';

/** Load the canonical school domain list from General Settings. */
export async function getAllowedDomains() {
    const response = await SEC_ApiCall('sysmanager/general-settings/allowed-domains');
    if (!response || response.message || !Array.isArray(response.allowedDomains) || response.allowedDomains.some(domain => typeof domain !== 'string')) {
        throw new Error('Approved domains could not be loaded.');
    }
    return response.allowedDomains;
}

/** Replace the complete domain list and require the API to confirm its canonical result. */
export async function saveAllowedDomains(allowedDomains) {
    const response = await SEC_DataApiPost('sysmanager/general-settings/allowed-domains', JSON.stringify({ allowedDomains }), {});
    if (!response || response.message || !Array.isArray(response.allowedDomains) || response.allowedDomains.some(domain => typeof domain !== 'string')) {
        throw new Error(response?.message || 'Approved domains could not be saved.');
    }
    return response.allowedDomains;
}

/** Load dashboard shortcuts in their canonical list-of-maps shape. */
export async function getDashboardLinks() {
    const response = await SEC_ApiCall('sysmanager/general-settings/dashboard-links');
    if (!response || response.message || !Array.isArray(response.dashboardLinks)) {
        throw new Error('Dashboard links could not be loaded.');
    }
    return response.dashboardLinks;
}

/** Replace the complete dashboard shortcut list. */
export async function saveDashboardLinks(dashboardLinks) {
    const response = await SEC_DataApiPost('sysmanager/general-settings/dashboard-links', JSON.stringify({ dashboardLinks }), {});
    if (!response || response.message || !Array.isArray(response.dashboardLinks)) {
        throw new Error(response?.message || 'Dashboard links could not be saved.');
    }
    return response.dashboardLinks;
}
